


































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';

import { config } from './config';
import { locales } from './locales';

import { mapActions, mapState } from 'vuex';
import { NotificationObj } from '../../modules/notification';

import { customizable } from '../../mixins/customizable';

const Props = Vue.extend({
	props: {
		/** The text of the close button */
		closeText: {
			type: String,
			default: locales.close
		}
	}
});

const MixinsDeclaration = mixins(Props, customizable(config));

/**
 * NotificationBar is a component that displays
 * a notification using a Snackbar
 */
@Component<NotificationBar>({
	computed: mapState('notification', ['notification']),
	methods: mapActions('notification', ['rmNotif']),
	watch: {
		notification() {
			// Compute snackbar color only when it's being displayed
			// to avoid seeing the default color on hide transition
			if (this.notification) {
				this.snackbarColor = this.options.snackBar.color as string || this.notification.type;
			}
		}
	}
})
export default class NotificationBar extends MixinsDeclaration {
	// We need to declare these types since there is
	// no Vuex instance when building the library
	rmNotif!: () => void;
	notification!: NotificationObj | null;

	snackbarColor: string | null = null;

	created() {
		// Remove notification if present when the
		// component is loaded the first time
		if (this.notification) {
			this.rmNotif();
		}
	}

	beforeDestroy() {
		// Clear notification on end lifecycle
		this.rmNotif();
	}
}
